import CreditCardForm from "./CreditCardForm";

export default CreditCardForm;



// WEBPACK FOOTER //
// ./src/apps/payment/components/CreditCardForm/index.js